<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">

        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>
            <form @submit.prevent="submit">
                <div class="card-header">
                    <h4 class="title">Order Detail</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            Order Number: <label>#{{samedata.orderreferenceid}}</label>
                        </div>
                        <div class="col-md-4">
                            Order Date: <label>{{samedata.created_at | formatDate}}</label>
                        </div>
                        <div class="col-md-4">
                            Order Status: <label>{{samedata.orderstatusname}}</label>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-4">
                            Name: <label>{{samedata.name}}</label>
                        </div>
                        <div class="col-md-4">
                            Number: <label>{{samedata.number}}</label>
                        </div>
                        <div class="col-md-4">
                            Email: <label>{{samedata.email}}</label>
                        </div>
                    </div>
                    <hr>

                    <div class="row">
                        <div class="col-md-6">
                            Billing Address: <label>{{samedata.houseappartment}}, {{samedata.area}}, {{samedata.city}}, {{samedata.state}}, {{samedata.country}}, {{samedata.pincode}}</label>
                            <br><label>Name: {{samedata.addressname}}</label>
                            <br><label>Number: {{samedata.addressnumber}}</label>
                            <br><label>Email: {{samedata.addressemail}}</label>

                        </div>
                        <div class="col-md-6">
                            Shipping Address: <label>{{samedata.houseappartment}}, {{samedata.area}}, {{samedata.city}}, {{samedata.state}}, {{samedata.country}}, {{samedata.pincode}}</label>
                            <br><label>Name: {{samedata.addressname}}</label>
                            <br><label>Number: {{samedata.addressnumber}}</label>
                            <br><label>Email: {{samedata.addressemail}}</label>
                        </div>
                    </div>
                    <hr>

                    <div class="row">
                        <div class="card-body table-responsive table-full-width">

                            <table class="table table-borderd mt-5" id="myTable">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Original Price</th>
                                        <th>Price</th>
                                        <th>Quantity</th>
                                        <th>Subtotal</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in orderdetail" v-bind:key="data.orderid">
                                        <td>{{data.productname}}</td>
                                        <td>₹{{data.price}}</td>
                                        <td v-if="data.sellingdiscountprice">₹{{data.sellingdiscountprice}}</td>
                                        <td v-else>₹{{data.sellingprice}}</td>
                                        <td>{{data.orderquantity}}</td>
                                        <td>₹{{data.producttotal}}</td>
                                        <td>₹{{data.cgst}}</td>
                                        <td>₹{{data.sgst}}</td>
                                        <td>₹{{data.producttotalwithtax}}</td>
                                    </tr>
                                </tbody>

                            </table>

                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-4">
                            <title class="orderdetailscustom">Status</title> <br>
                            <select class="form-control" v-model.trim="$v.currentstatus.$model">
                                <option disabled value>Select order status</option>
                                <option v-for="(list, index) in orderstatus" :value="list.orderstatusid" :key="index">
                                    {{ list.orderstatusname }}
                                </option>
                            </select>
                            <button type="submit" class="btn btn-secondary dashboard">Update</button>
                        </div>
                        <div class="col-md-8">
                            <title class="orderdetailscustom">Order Total</title><br>
                            Subtotal: <label>₹{{samedata.subtotal}}</label><br>
                            CGST: <label>₹{{samedata.subtotal * 9 / 100}}</label><br>
                            SGST: <label>₹{{samedata.subtotal * 9 / 100}}</label>
                            <hr>
                            Total: <label>₹{{samedata.totalprice}}</label><br>

                        </div>

                    </div>

                </div>
            </form>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import Auth from '../../../Auth.js';

import {
    required,
    minLength,
    maxLength,
    between,
    email,
} from "vuelidate/lib/validators";
export default {
    name: 'addLead',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,
            orderdetail: [],
            samedata: [],
            orderstatus: [],
            currentstatus: '',
            auth: '',
        }
    },

    validations: {
        currentstatus: {
            required,
        },
    },

    methods: {

        submit() {
            let formData = new FormData();
            formData.append('orderstatus', this.currentstatus);
            for (var i = 0; i < this.orderdetail.length; i++) {
                formData.append('orderid[' + i + ']', this.orderdetail[i].orderid);
            }
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/orderstatus/update/` + this.samedata.orderreferenceid, formData)
                    .then(({
                        data
                    }) => {
                        this.flashMessage.success({
                            message: 'Order Status Update Successfully',
                        });
                        this.$router.push('/admin/dashboard/orders');

                    })
                // .catch((error) => {
                //     console.log(error.response);
                // });
            }
        },
    },

    async mounted() {

        const orderdetail = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/orderdetails/` + this.$route.params.id);
        this.orderdetail = orderdetail.data;
        this.samedata = orderdetail.data[0];
        this.currentstatus = orderdetail.data[0].orderstatus;

        const orderstatus = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getordersstatus`);
        this.orderstatus = orderstatus.data;

        this.auth = Auth.user;
    },

};
</script>

<style lang="scss">
.scrollable {
    overflow-y: scroll;
}

#myTable {
    margin-top: 0px !important;
}

title.orderdetailscustom {
    font-weight: 600;
    display: flex;
    font-size: larger;
}
</style>
